import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=06b07824&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=06b07824&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b07824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b07824')) {
      api.createRecord('06b07824', component.options)
    } else {
      api.reload('06b07824', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=06b07824&scoped=true", function () {
      api.rerender('06b07824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/modules/upload_modal/upload.vue"
export default component.exports